export const getInitialState = () => ({
	domains: [],
	generalErrors: []
});
